import { imgs } from "../assets/imgs";

export const Press = () => {
    document.title = "youngStartup Ventures | Press";

    return (
        <div className='press-page'>
            <h1 className='theme-liner'
                style={
                    { 
                        backgroundImage: `url(${imgs.venue.ventureBannerDesktopNight})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        padding: '0em 0em 7em 0em' 
                    }
                }>
                Press</h1>
            <div className='info-section'>
                <section>
                    <div>
                        <p>New England Venture Summit Brings Together 140+ Venture Capitalists and 170 Top Innovators in Boston</p>
                    </div>
                    <div>
                        <b>Boston, MA</b> — youngStartup Ventures successfully hosted the <b>2025 New England Venture Summit</b>, bringing together <b>140+ venture capitalists</b>, <b>corporate VCs</b>, <b>angel investors</b>, and <b>170 Top Innovators</b> for two days of high-impact conversations, company presentations, and curated networking in the Greater Boston area.
                        <br/>
                        <br/>
                        The Summit featured <b>12 venture panels and workshops</b>, sector-focused programming across <b>AI</b>, <b>FinTech</b>, <b>Climate & CleanTech</b>, <b>Life Sciences & Healthcare</b>, <b>MedTech</b>, and more than <b>1,400 one-on-one investor–founder meetings</b> facilitated through structured matchmaking.
                        <br/>
                        <br/>
                        Participants included active investors from leading venture firms, corporate investment arms, and angel investors alongside founders of venture-backed and emerging companies from across the globe with a strong emphasis on North American companies.
                    </div>
                </section>
                <section>
                    <div><img src={imgs.press.pressInfo} alt="press info" /></div>
                    <div>
                        “The New England Venture Summit continues to prove that focused, high-quality, in-person engagement is where real connections and capital formation happen,” said <b>Joe Benjamin</b>, Founder & CEO of youngStartup Ventures. 
                        <br/>
                        “Our goal is not scale for scale’s sake, but relevance—bringing the right investors together with the right founders in an environment designed for meaningful interaction.”
                        <br/>
                        <br/>
                        The Summit was supported by sponsors and partners spanning legal, accounting, HR, and professional services, all of whom engaged directly with founders and investors throughout the event via sponsor lounges, roundtables, and dedicated networking sessions.
                        <br/>
                        <br/>
                        With a growing national footprint, youngStartup Ventures produces multiple venture-focused summits annually, connecting investors and founders across technology, healthcare, climate, and emerging innovation sectors.
                        <br/>
                        <br/>
                        <b>About youngStartup Ventures</b>
                        <br/>
                        youngStartup Ventures is a leading producer of venture capital conferences and summits across the United States. Its events bring together venture capitalists, corporate investors, angel investors, and founders of emerging and venture-backed companies for curated content, one-on-one meetings, and high-touch networking.
                    </div>
                </section>
            </div>
        </div>
    )
}